import { BaseTransport } from '../transports'
import { RequestUserConfig } from '../common/types'
import { NetworkService } from '../services'
import { AvailabilityResponseTransport } from '../transports/availability-transport'

class AvailabilityClient {
    public getAvailableArrivalDates({
        user,
        params,
        signal,
    }: {
        user: RequestUserConfig
        params: any
        signal?: AbortController | null
    }): Promise<BaseTransport<AvailabilityResponseTransport>> {
        const { listingId, month, duration } = params
        const headers = {
            ...(user.session?.id && { 'x-session-id': user.session.id }),
        }

        return NetworkService.get({
            url: `/api/v1/availability/listings/${listingId}/arrivals/${month}`,
            headers,
            params: { duration },
            restConfig: { signal },
        })
    }

    public getAvailableDepartureDates({
        user,
        params,
        signal,
    }: {
        user: RequestUserConfig
        params: any
        signal: AbortController | null
    }): Promise<BaseTransport<AvailabilityResponseTransport>> {
        const { listingId, arrivalDate, month, duration } = params
        const headers = {
            ...(user.session?.id && { 'x-session-id': user.session.id }),
        }

        return NetworkService.get({
            url: `/api/v1/availability/listings/${listingId}/departures/${arrivalDate}/${month}`,
            headers,
            params: { duration },
            restConfig: { signal },
        })
    }
}

export default new AvailabilityClient()
